<app-header></app-header>
    <div class="content-container">
        <!-- OneTrust Cookies Settings button start -->

        <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>

        <!-- OneTrust Cookies Settings button end -->

        <!-- OneTrust Cookies List start -->
        <div id="ot-sdk-cookie-policy"></div>

        <!-- OneTrust Cookies List end -->
    </div>
<app-footer></app-footer>